<template>
  <div class="client-container">
    <!-- client filter menu -->
    <filter-for-clients :is-mobile-device="isMobileDevice"
                        @apply-filters="applyFilters"
                        @set-pagination-page="setPaginationPage"
                        @get-my-position="getMyPosition"/>
    <div v-if="!isMobileDevice"
         :class="{'is-detailed-filter-open': isDetailedFilterOpen}"
         class="filter-container-space-helper"></div>
    <div v-else
         :class="{'is-detailed-filter-open': isDetailedFilterOpen}"
         class="filter-container-mobile-space-helper"></div>
    <!-- ./client filter menu -->
    <!-- second menu -->
    <div class="row text-center">
      <!-- un select client -->
      <div v-if="!isMobileDevice"
           class="small-6 medium-4 columns">
        <button class="ui icon button"
                title="Kiválasztás megszüntetése"
                @click="unSelectClient">
          <i class="undo icon"></i> Kiválasztás megszüntetése
        </button>
      </div>
      <button v-if="isMobileDevice && isSelectedClient"
              class="ui icon button mobile-undo-button"
              title="Kiválasztás megszüntetése"
              @click="unSelectClient">
        <i class="undo icon"></i> Kiválasztás megszüntetése
      </button>
      <!-- ./un select client -->
      <!-- pagination -->
      <div class="small-12 medium-4 columns">
        <div class="ui pagination menu">
          <a v-for="i in paginationPageCount"
             :class="{'active': i === currentPaginationPage}"
             class="item"
             @click="setPaginationPage(i)">
            {{ i }}
          </a>
        </div>
      </div>
      <!-- ./pagination -->
      <!-- sort -->
      <div class="small-12 medium-4 columns">
        <div class="ui form">
          <div class="field">
            <select v-model="sortKey">
              <option value="descByName">Név szerint csökkenő</option>
              <option value="ascByName">Név szerint növekvő</option>
              <option value="ascByDistance">Távolság szerint növekvő</option>
            </select>
          </div>
        </div>
      </div>
      <!-- ./sort -->
    </div>
    <!-- ./second menu -->
    <!-- client cards -->
    <div v-if="filteredClients.withPagination.length > 0"
         class="clients-container"
         data-v-desktop-logged-out-step="4">
      <client-cards v-if="!isListView"
                    :current-pagination-page="currentPaginationPage"
                    :favorite-client-click="favoriteClientClick"
                    :filtered-clients="filteredClients.withPagination"
                    :get-distance-text="getDistanceText"
                    :get-global-subject-type-by-key="getGlobalSubjectTypeByKey"
                    :get-google-direction-url="getGoogleDirectionUrl"
                    :is-featured-client="isFeaturedClient"
                    :is-logged-in="isLoggedIn"
                    :is-mobile-device="isMobileDevice"
                    :is-this-my-favorite-client="isThisMyFavoriteClient"
                    @create-new-reservation="(payload) => this.$emit('create-new-reservation', payload)"
                    @resign-reservation="(payload) => this.$emit('resign-reservation', payload)"
      />

      <client-list v-else
                   :current-pagination-page="currentPaginationPage"
                   :favorite-client-click="favoriteClientClick"
                   :filtered-clients="filteredClients.withPagination"
                   :get-distance-text="getDistanceText"
                   :get-global-subject-type-by-key="getGlobalSubjectTypeByKey"
                   :get-google-direction-url="getGoogleDirectionUrl"
                   :is-featured-client="isFeaturedClient"
                   :is-logged-in="isLoggedIn"
                   :is-mobile-device="isMobileDevice"
                   :is-this-my-favorite-client="isThisMyFavoriteClient"
                   @create-new-reservation="(payload) => this.$emit('create-new-reservation', payload)"
                   @resign-reservation="(payload) => this.$emit('resign-reservation', payload)"
      />
    </div>
    <div v-else
         class="no-result-placeholder">
      <div>
        <i class="ban icon"></i>
        <h2>Sajnos nincs találtat</h2>
        <h3>Módosítsd a keresési feltételeket, használd a részetes keresőt!</h3>
      </div>
    </div>
    <!-- ./client cards -->
  </div>
</template>

<script>
import utils from '../../utils'
import notify from '../../notify'
import FilterForClients from './FilterForClients'
import ClientCards from './ClientCards'
import ClientList from './ClientList'
import eventBus from '@/main';

export default {
  props: ['isLoggedIn', 'isMobileDevice'],
  data () {
    return {
      sortKey: 'ascByDistance',
      selectedGlobalSubjectType: 'all',
      selectedFilterDate: null,
      selectedFilterTime: null,
      distanceFilter: 20000,
      searchFilter: null,
      currentPaginationPage: 1,
      paginationItemPerPage: 8,
      linkedClient: null,
    }
  },
  methods: {
    selectClient (domain) {
      this.$store.dispatch('selectClient', domain);

      if (!this.isListView) {
        // eslint-disable-next-line
        $('html, body').animate({ scrollTop: ($('.schedule-table-container-wrapper').offset().top - 50) }, 500)
      }
    },
    getDistanceText (clientLat, clientLng) {
      let currentPosition = this.$store.state.currentPosition
      if (currentPosition && clientLat && clientLng) {
        if (currentPosition.hasOwnProperty('lat') && currentPosition.hasOwnProperty('lng')) {
          let distance = utils.getDistance(currentPosition.lat, currentPosition.lng,
            clientLat, clientLng)
          distance = utils.round(distance, 1)
          return distance.toString()
        }
      }
      return '??'
    },
    getGoogleDirectionUrl (client) {
      if (client.hasOwnProperty('lat') && client.hasOwnProperty('lng')) {
        if (client.lat && client.lng) {
          let googleDirUrl = 'https://www.google.com/maps/dir/?api=1&origin=&destination=' + client.lat + ',' +
            client.lng
          if (client.hasOwnProperty('googlePlaceID')) {
            if (client.googlePlaceID) {
              googleDirUrl += '&destination_place_id=' + client.googlePlaceID
            }
          }
          return googleDirUrl
        }
      }
      return null
    },
    getMyPosition () {
      let self = this
      navigator.geolocation.getCurrentPosition(
        function success (position) {
          let currentPosition = { lat: position.coords.latitude, lng: position.coords.longitude }
          self.$store.dispatch('setCurrentPosition', { currentPosition: currentPosition })
          self.$store.dispatch('isAccessCurrentPosition', { isAccessCurrentPosition: true })
        },
        function error (msg) {
          self.$store.dispatch('isAccessCurrentPosition', { isAccessCurrentPosition: false })
          notify.warning('A távolság meghatározásához engedélyezd a helymeghatározást')
          console.warn(msg)
        })
    },
    favoriteClientClick (domain) {
      if (!this.isLoggedIn) {
        notify.warning('A kedvencek használata előtt jelentkezz be!')
      } else {
        if (this.$store.state.user) {
          if (this.$store.state.user.favoriteClient) {
            // you have a favorite client
            let myFavoriteClient = this.$store.state.user.favoriteClient
            if (myFavoriteClient === domain) {
              // delete favorite client
              this.$emit('delete-favorite-client')
            } else {
              // change favorite client
              let self = this
              notify.confirmation('Biztos módosítod a kedvenc pályád?')
                .then(() => {
                  // yes
                  self.$emit('change-favorite-client', domain)
                }, () => {
                  // no
                })
            }
          } else {
            // currently you haven't any favorite client
            this.$emit('insert-favorite-client', domain)
          }
        } else {
          notify.warning('Váratlan hiba történt, kérjük frissítsd az oldalt és próbáld meg ismét!')
        }
      }
    },
    isFeaturedClient (client) {
      return client.featuredPosition !== null
    },
    applyFilters (data) {
      this.setPaginationPage(1)
      if (data.hasOwnProperty('searchFilter')) {
        this.searchFilter = data.searchFilter
      }
      if (data.hasOwnProperty('distanceFilter')) {
        this.distanceFilter = data.distanceFilter
      }
    },
    setPaginationPage (newPaginationPageNumber) {
      this.unSelectClient()
      this.currentPaginationPage = newPaginationPageNumber
    },
    unSelectClient () {
      this.$store.dispatch('unSelectClient')
      // eslint-disable-next-line
      $('.schedule-table-place').removeClass('active') //TODO
    },
    getGlobalSubjectTypeByKey (key) {
      let globalSubjectTypes = this.$store.state.globalSubjectTypes
      let length = globalSubjectTypes.length
      for (let i = 0; i < length; i++) {
        let subjectType = globalSubjectTypes[i]
        if (subjectType.key === key) {
          return subjectType
        }
      }

      return { key: '-', name: '-', iconUrl: '-' }
    },
  },
  computed: {
    filteredClients: function () {
      let clients = this.$store.state.clients
      let filteredClients = []
      let helperArray = []
      let featuredClients = []
      let results = []
      let sortKey = this.sortKey
      let selectedGlobalSubjectType = this.selectedGlobalSubjectType
      let searchFilter = null
      let curPagPageNumber = this.currentPaginationPage
      let pagItemPerPage = this.paginationItemPerPage
      if (this.searchFilter) {
        searchFilter = this.searchFilter.toLowerCase()
      }
      let currentPosition = this.$store.state.currentPosition
      let myFavoriteClient = null
      if (this.$store.state.user) {
        myFavoriteClient = this.$store.state.user.favoriteClient
      }
      let availableClientsAtFilteredTime = this.$store.state.filteredFreeClients
      let linkedClient = this.linkedClient

      // subject type filter
      if (!selectedGlobalSubjectType || selectedGlobalSubjectType === 'all') {
        for (let client of clients) {
          if (client.domain !== myFavoriteClient) {
            filteredClients.push(client)
          }
        }
      } else {
        for (let client of clients) {
          // global subject type filter
          if (client.availableGlobalSubjectTypes.includes(selectedGlobalSubjectType)) {
            if (client.domain !== myFavoriteClient) {
              filteredClients.push(client)
            }
          }
        }
      }

      // separate featured and simple clients
      helperArray = []
      for (let client of filteredClients) {
        if (client.featuredPosition) {
          featuredClients.push(client)
        } else {
          helperArray.push(client)
        }
      }
      featuredClients.sort((a, b) => {
        if (a.featuredPosition > b.featuredPosition) {
          return 1
        }
        return -1
      })
      filteredClients = helperArray

      // search filter
      // availableGlobalSubjectTypes, city, name
      let searchKeys = []
      let isIncludeAllKey
      let clientSearchString
      helperArray = []
      if (searchFilter && searchFilter !== '') {
        if (searchFilter.includes(' ')) {
          searchKeys = searchFilter.split(' ')
        } else {
          searchKeys.push(searchFilter)
        }
        for (let client of filteredClients) {
          isIncludeAllKey = true
          clientSearchString = '' + client.name.toLowerCase() + ', ' + client.city.toLowerCase() +
            (client.availableGlobalSubjectTypes.join()).toLowerCase()
          for (let key of searchKeys) {
            if (key !== '') {
              if (!clientSearchString.includes(key)) {
                isIncludeAllKey = false
              }
            }
          }
          if (isIncludeAllKey) {
            helperArray.push(client)
          }
        }
        filteredClients = helperArray
      }
      // set the distance filter min/max range before we filter by distance
      /*
      if (currentPosition) {
        if (currentPosition.hasOwnProperty('lat') && currentPosition.hasOwnProperty('lng') &&
            currentPosition.lat && currentPosition.lng) {
          if (filteredClients.length > 1) {
            let minValue = utils.getDistance(filteredClients[0].lat, filteredClients[0].lng,
            currentPosition.lat, currentPosition.lng)
            let maxValue = minValue
            // search on filtered clients
            for (let client of filteredClients) {
              let clientDistance = utils.getDistance(client.lat, client.lng,
              currentPosition.lat, currentPosition.lng)
              if (clientDistance < minValue) {
                minValue = clientDistance
              } else if (clientDistance > maxValue) {
                maxValue = clientDistance
              }
            }
            // search on featured clients
            for (let client of featuredClients) {
              let clientDistance = utils.getDistance(client.lat, client.lng,
                currentPosition.lat, currentPosition.lng)
              if (clientDistance < minValue) {
                minValue = clientDistance
              } else if (clientDistance > maxValue) {
                maxValue = clientDistance
              }
            }
            // this.rangeSliderOptions.min = Math.floor(minValue)
            this.rangeSliderOptions.max = Math.ceil(maxValue)
          } else if (filteredClients === 1) {
            // this.rangeSliderOptions.min = 0
            this.rangeSliderOptions.max = utils.getDistance(filteredClients[0].lat, filteredClients[0].lng,
            currentPosition.lat, currentPosition.lng)
          } else {
            // this.rangeSliderOptions.min = 0
            this.rangeSliderOptions.max = 50
          }
        }
      }
      */
      helperArray = []
      // distance filter
      if (currentPosition) {
        for (let i in filteredClients) {
          // let minDistance = parseFloat(this.distanceFilter[0])
          // let maxDistance = parseFloat(this.distanceFilter[1])
          let maxDistance = parseFloat(this.distanceFilter)
          let currentDistance = Math.floor(utils.getDistance(filteredClients[i].lat, filteredClients[i].lng,
            currentPosition.lat, currentPosition.lng))
          if (// minDistance <= currentDistance &&
            maxDistance >= currentDistance) {
            helperArray.push(filteredClients[i])
          }
        }
      } else {
        helperArray = filteredClients
      }

      filteredClients = helperArray

      // sort only if need
      if (sortKey !== 'default' || sortKey) {
        if (sortKey === 'descByName') {
          filteredClients.sort(function (a, b) {
            if (a.name < b.name) return 1
            if (a.name > b.name) return -1
            return 0
          })
        } else if (sortKey === 'ascByName') {
          filteredClients.sort(function (a, b) {
            if (a.name < b.name) return -1
            if (a.name > b.name) return 1
            return 0
          })
        } else if (sortKey === 'ascByDistance') {
          if (currentPosition) {
            filteredClients.sort((a, b) => {
              if (utils.getDistance(a.lat, a.lng, currentPosition.lat, currentPosition.lng) <=
                utils.getDistance(b.lat, b.lng, currentPosition.lat, currentPosition.lng)) {
                return -1
              } else {
                return 1
              }
            })
          }
          /*
          for (let client of filteredClients) {
          }
          */
        }
      }

      // add your favorite client to the first place
      if (myFavoriteClient) {
        for (let client of clients) {
          if (myFavoriteClient === client.domain) {
            results.push(client)
          }
        }
      }

      results = results.concat(featuredClients, filteredClients)

      /* if filtered by time */
      if (availableClientsAtFilteredTime) {
        helperArray = []
        for (let i in results) {
          for (let j in availableClientsAtFilteredTime) {
            if (results[i].domain === availableClientsAtFilteredTime[j]) {
              helperArray.push(results[i])
            }
          }
        }
        results = helperArray
      }

      /* linked client add to first place (if has link)*/
      if (linkedClient) {
        for (let i in results) {
          let client = results[i]
          if (client?.domain === linkedClient) {
            results.splice(i, 1)
          }
        }
        for (let i in clients) {
          let client = clients[i]
          if (client?.domain === linkedClient) {
            results.splice(0, 0, client)
          }
        }
        console.log('done')
      }

      /* ./linked client add to first place */

      /* pagination */
      let startIndex = (curPagPageNumber - 1) * pagItemPerPage
      let endIndex = curPagPageNumber * pagItemPerPage
      // console.log(results)
      let resultsWithoutPagination = results

      
      let selectedClient = clients.find(c => c.domain == this.$store.state.currentClientDomain);
      

      if (selectedClient && !resultsWithoutPagination.find(c => c.domain == this.$store.state.currentClientDomain)) {
        resultsWithoutPagination.unshift(selectedClient);
      }
      results = results.slice(startIndex, endIndex)
      /* ./pagination */

      return { withPagination: results, withoutPagination: resultsWithoutPagination }
    },
    isAccessCurrentPosition () {
      return this.$store.state.isAccessCurrentPosition
    },
    isThisMyFavoriteClient () {
      return function (client) {
        if (this.$store.state.user) {
          if (this.$store.state.user.favoriteClient) {
            // console.log('????????????????????')
            // console.log(this.$store.state.user.favoriteClient)
            // console.log('????????????????????')
            let myFavoriteClient = this.$store.state.user.favoriteClient

            if (myFavoriteClient) {
              if (myFavoriteClient === client) {
                return true
              }
            }
            return false
          }
          return false
        }
        return false
      }
    },
    hasFavoriteClient () {
      return this.$store.state.user.favoriteClient !== false
    },
    isDetailedFilterOpen () {
      return this.$store.state.isDetailedFilterOpen
    },
    currentClientDomain () {
      return this.$store.state.currentClientDomain
    },
    paginationPageCount () {
      let clientCount = this.filteredClients.withoutPagination.length
      // let clientCount = this.$store.state.clients.length
      return Math.ceil(clientCount / this.paginationItemPerPage)
    },
    isSelectedClient () {
      return !!this.$store.state.currentClientDomain
    },
    isListView () {
      return this.$store.state.isListView
    },
  },
  created: function () {
    this.getMyPosition()
    let query = this.$route.query
    if (query?.linked_client) {
      // eslint-disable-next-line
      this.linkedClient = query.linked_client
      // console.log('###linkedClient: ', this.linkedClient)
      // console.log('### filteredCLients: ', this.filteredClients)
      // console.log('### clients: ', this.$store.state.clients)
      console.log('created')
    }
  },
  beforeDestroy: function () {
    eventBus.$off('AfterSelectClient');
  },
  mounted: function () {
    eventBus.$on('AfterSelectClient', () => {
      console.log('AfterSelectClient');
      // eslint-disable-next-line
      $('html, body').animate({ scrollTop: ($('.schedule-table-container-wrapper').offset().top - 50) }, 500);
    });


    if (this.linkedClient) {
      this.$nextTick(function () {
        // induláskor megnyitja a táblázat első elemét
        if (this.filteredClients.withoutPagination.length > 0) {
          if (this.filteredClients.withoutPagination[0].hasOwnProperty('domain')) {
            this.selectClient(0, this.filteredClients.withoutPagination[0].domain)
            /* eslint-disable */
            $('html, body').animate({
              scrollTop: ($('.filter-container').offset().top + 300),
            }, 500)
          }
        }
      })
    }

    // FIXME: IDEIGLENESEN AMEDDIG NINCS MAS MEGOLDAS
    /*
    this.$nextTick(function () {
      // induláskor megnyitja a táblázat első elemét
      if (this.filteredClients.length > 0) {
        if (this.filteredClients[0].hasOwnProperty('domain')) {
          this.selectClient(0, this.filteredClients[0].domain)
          /!* eslint-disable *!/
          $('html, body').animate({
            scrollTop: ($(".filter-container").offset().top + 300)
          }, 500)
        }
      }
    })
    */
  },
  components: {
    FilterForClients,
    ClientCards,
    ClientList,
  },
}

</script>

<style scoped>
.client-container {
  /*height: 12rem;*/
  margin-bottom: 1rem;
}

.pagination {
  margin-bottom: 1rem !important;
}

.filter-container-space-helper {
  height: 100px;
  transition: height 1s ease-in;
}

.filter-container-mobile-space-helper {
  height: 150px;
  transition: height 1s ease-in;
}

.filter-container-space-helper.is-detailed-filter-open {
  height: 250px;
  transition: height 1s ease-out;
}

.filter-container-mobile-space-helper.is-detailed-filter-open {
  height: 650px;
  transition: height 1s ease-out;
}

.vue-slider-component .vue-slider-tooltip {
  border-color: #00878d !important;
  background: #00878d !important;
}

.mobile-undo-button {
  width: 100%;
  left: 0;
  bottom: 0;
  position: fixed;
  z-index: 99;
}
</style>
